import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { useSpinningText } from '@/helpers/composables/useSpinningText';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoneOffers',
  props: {
    title: null,
    offers: null,
    seasonNumber: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	offers: TitleDetail['offers'];
	seasonNumber?: number | undefined;
};

const { language } = useLanguageStore();



const { getInfoTextBlock } = useSpinningText(toRefs(props));

const text = computed(() => {
	switch (language.value) {
		case 'fi':
			return getInfoTextBlock(
				'none',
				'Koitamme jatkuvasti lisätä uusia palveluita valikoimaamme, mutta valitettavasti tällä kertaa emme löytäneet yhtään tarjousta elokuvalle',
				'netissä. Palaa pian takaisin katsomaan olemmeko löytäneet uusia tarjouksia'
			);
		case 'ru':
			return getInfoTextBlock(
				'none',
				'Мы стараемся регулярно добавлять новых провайдеров, но мы не смогли найти предложения для',
				'онлайн. Пожалуйста, повторите запрос позже, чтобы проверить появилось ли что-то новое'
			);
		case 'it':
			return getInfoTextBlock(
				'none',
				"Ci impegnamo ad aggiungere sempre nuovi providers, ma non siamo riusciti a trovare un'offerta online per",
				'. Per favore, ritorna presto e controlla se ci sono delle novità'
			);
		case 'de':
			return getInfoTextBlock(
				'none',
				'Wir versuchen fortwährend neue Anbieter hinzuzufügen, aber leider haben wir keine Angebote gefunden. Komm doch bald wieder um zu sehen, ob',
				'jetzt online verfügbar ist'
			);
		case 'pt':
			return getInfoTextBlock('none', '', 'em breve disponível novamente');
		case 'fr':
			return getInfoTextBlock(
				'none',
				'Nous ajoutons régulièrement de nouveaux services de VOD et SVOD mais nous n`avons pas trouvé d`offre pour',
				'en streaming. Veuillez revenir plus tard pour voir si une offre a été ajoutée.'
			);
		case 'es':
			return getInfoTextBlock('none', 'No hay oferta para', 'en este momento');
		case 'ja':
			return `JustWatchでは常に視聴情報を集めて、お届けしています。あいにく、現在${props.title}の視聴情報はありません。近日、再検索をして、${props.title}の最新情報をチェックしてください`;
		case 'ko':
			return `JustWatch는 항상 최신 영화 및 TV 프로그램 정보를 수집하여 제공하기 위해 노력합니다. 아쉽게도 현재 ${props.title}의 영상을 찾을 수 없습니다. 가까운 시일 내에 다시 검색해보세요`;
		case 'ro':
			return getInfoTextBlock(
				'none',
				'Încercăm să adăugăm noi furnizori în mod constant, dar nu am putut găsi o ofertă pentru',
				'online. Reveniți curând pentru a verifica dacă a apărut ceva nou.'
			);
		case 'hu':
			return getInfoTextBlock(
				'none',
				'Folyamatosan próbáljuk új szolgáltatókkal bővíteni a kínálatunkat, de nem találtunk online ajánlatot a(z)',
				'tartalomhoz. Kérjük, térjen vissza hamarosan, és ellenőrizze, hogy megjelent-e valami újdonság.'
			);
		case 'cs':
			return getInfoTextBlock(
				'none',
				'Neustále se snažíme přidat nové poskytovatele, ale nabídku na sledování titulu',
				'online se nám bohužel najít nepodařilo. Vraťte se, prosím, brzy a zkontrolujte, zda se situace nezměnila.'
			);
		case 'bg':
			return getInfoTextBlock(
				'none',
				'Стремим се непрекъснато да добавяме нови доставчици, но не намерихме оферта за',
				'онлайн. Моля, проверете отново скоро дали има нещо ново.'
			);
		case 'ar':
			return getInfoTextBlock(
				'none',
				'نسعى باستمرار لإضافة مقدمي خدمة جدد، لكن لم نتمكن من العثور على عرض لمشاهدة',
				'أونلاين. نرجو منكم العودة قريباً للاطلاع على كل جديد لدينا'
			);
		case 'pt':
			return getInfoTextBlock(
				'none',
				'Estamos tentando adicionar novos provedores, mas no momento não conseguimos encontrar uma oferta para assistir',
				'online. Por favor, retorne em breve para verificar se há alguma novidade'
			);
		case 'tr':
			return getInfoTextBlock(
				'none',
				'Sistemimize devamlı servisler eklemeye çalışsak da',
				'adlı yapım için çevrimiçi izleme seçeneği bulamadık. Yeniden kontrol etmek için sitemize daha sonra tekrar göz atın'
			);
		case 'sq':
			return getInfoTextBlock(
				'none',
				'Ne përpiqemi të shtojmë ofrues të rinj vazhdimisht, por nuk mundëm të gjejmë një ofertë për',
				'online. Ju lutemi kthehuni së shpejti për të kontrolluar nëse ka diçka të re'
			);
		case 'pl':
			return getInfoTextBlock(
				'none',
				'Staramy się na bieżąco dodawać nowe serwisy, jednak na chwilę obecną nie udało nam się znaleźć',
				'w ofercie online. Zajrzyj do nas wkrótce, aby sprawdzić, co nowego'
			);
		case 'ro':
			return getInfoTextBlock(
				'none',
				'Încercăm să adăugăm constant noi servicii de streaming, dar nu am găsit o ofertă online pentru',
				'. Te rugăm să revii în curând și să verifici ce e nou'
			);
		case 'az':
			return getInfoTextBlock(
				'none',
				'Biz daim yeni provayder əlavə etməyə çalışırıq, lakin',
				'üçün onlayn təklif tapa bilmədik. Yenilik olub-olmadığını yoxlamaq üçün tezliklə yenidən qayıdın'
			);
		case 'el':
			return getInfoTextBlock(
				'none',
				'Προσπαθούμε να προσθέτουμε συνεχώς νέους παρόχους αλλά δεν μπορέσαμε να βρούμε μια προσφορά για τον τίτλο',
				'online. Ελέγξτε το ξανά σύντομα για να δείτε αν υπάρχει κάποια καινούργια εξέλιξη'
			);
		case 'sr':
			return getInfoTextBlock(
				'none',
				'Pokušavamo da stalno dodajemo nove dobavljače, ali nismo mogli da pronađemo ponudu za',
				'na mreži. Vratite se ponovo uskoro da proverite da li ima nečeg novog'
			);
		case 'sv':
			return getInfoTextBlock(
				'none',
				'Vi försöker hela tiden lägga till nya leverantörer men vi kunde inte hitta något erbjudande för',
				'online. Kom tillbaka snart igen för att kolla om det finns något nytt'
			);
		case 'uk':
			return getInfoTextBlock(
				'none',
				'Ми намагаємося постійно додавати нових провайдерів, але нам не вдалося знайти пропозицію трансляції',
				'онлайн. Будь ласка, поверніться незабаром знову, щоб дізнатися, чи з’явились новинки'
			);
		case 'ur':
			return getInfoTextBlock(
				'none',
				'ہم   نئے پرووائڈر کو شامل کرنے کی مسلسل کوشش میں رہتے ہیں لیکن ہمیں آن لائن',
				'کیلئےکوئی پیشکش نہیں مل سکی۔ برائے مہربانی جلد دوبارہ واپس آکر چیک کریں کہ آیا کچھ نیا ہے یا نہیں۔'
			);
		case 'zh':
			return getInfoTextBlock(
				'none',
				'我们会持续添加新的平台，但目前无法在网上找到',
				'的观看资源。请稍后再回来查看是否有更新。'
			);
		case 'en':
		default:
			return getInfoTextBlock(
				'none',
				"We try to add new providers constantly but we couldn't find an offer for",
				"online. Please come back again soon to check if there's something new"
			);
	}
});

return { __sfc: true,language, props, getInfoTextBlock, text }
}

})